import { createSlice } from '@reduxjs/toolkit';
import { getLatestCredit } from './credit.actions';

export interface InitialStateProps {
  creditDetails: {
    creditRemaining: number;
    featureName: string;
    lastCreditedDate: string;
  };
  apiFailure: boolean;
}
const initialState: InitialStateProps = {
  creditDetails: {
    creditRemaining: 0,
    featureName: '',
    lastCreditedDate: '',
  },
  apiFailure: false,
};

const userLogin = createSlice({
  name: 'credit',
  initialState,
  reducers: {
    resetCredit: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(getLatestCredit.fulfilled, (state, action) => {
      const data = {
        creditRemaining: action.payload,
        featureName: '',
        lastCreditedDate: '',
      };
      state.creditDetails = data;
      state.apiFailure = false;
    });
    builder.addCase(getLatestCredit.rejected, (state) => {
      const data = {
        creditRemaining: 0,
        featureName: '',
        lastCreditedDate: '',
      };
      state.creditDetails = data;
      state.apiFailure = true;
    });
  },
});

export const { resetCredit } = userLogin.actions;

export default userLogin.reducer;
